import {
  Component,
  ContentChildren,
  QueryList,
  AfterContentInit,
  signal,
  Input,
  OnDestroy,
} from '@angular/core';
import { BASIC_IMPORTS } from '../../../imports/common-imports';
import { TabComponent } from '../tab/tab.component';
import { TabHeaderComponent } from '../tab-header/tab-header.component';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-tab-group',
  standalone: true,
  imports: [BASIC_IMPORTS, TabHeaderComponent],
  templateUrl: './tab-group.component.html',
  styleUrl: './tab-group.component.scss',
})
export class TabGroupComponent implements AfterContentInit, OnDestroy {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  @Input() style: 'bordered' | 'underline' = 'bordered';
  activeTabIndex = signal(0);
  private tabsSubscription?: Subscription;

  ngAfterContentInit() {
    // Set the first tab as active by default
    this.setActiveTab(0);

    // Subscribe to tabs changes to reset when content changes
    this.tabsSubscription = this.tabs.changes.subscribe(() => {
      this.setActiveTab(0);
    });
  }

  ngOnDestroy() {
    this.tabsSubscription?.unsubscribe();
  }

  setActiveTab(index: number) {
    this.activeTabIndex.set(index);

    // Update all tabs' active state
    this.tabs.forEach((tab, i) => {
      tab.isActive.set(i === index);
    });
  }
}
